import { render, staticRenderFns } from "./TermsCard.vue?vue&type=template&id=4da7220b&scoped=true&"
import script from "./TermsCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./TermsCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TermsCard.vue?vue&type=style&index=0&id=4da7220b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da7220b",
  null
  
)

export default component.exports